// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"62f098be","160":"34a43941","208":"efe0388a","293":"e25615cd","516":"64adc63b","519":"3399366a","917":"fcf5200c","946":"1b2065e6"}[chunkId] + ".chunk.js";
};